import { render, staticRenderFns } from "./Expire_details.vue?vue&type=template&id=33ad2beb&scoped=true&"
import script from "./Expire_details.vue?vue&type=script&lang=js&"
export * from "./Expire_details.vue?vue&type=script&lang=js&"
import style0 from "./Expire_details.vue?vue&type=style&index=0&id=33ad2beb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ad2beb",
  null
  
)

export default component.exports